import { NotificationManager } from "react-notifications";
import { orderSetCoupone } from "../../../api/couponeService";

export function CouponLabel(props) {
  const { coupon, loader, refetch } = props;

  const handleCodeChange = async () => {
    loader();
    const { data } = await orderSetCoupone(
      {
        coupon: "",
      },
      (error) => {
        loader(false);
        NotificationManager.error(error.response.data.message, "Error");
      }
    );

    NotificationManager.success(data.response);
    refetch();
    loader(false);
  };

  return (
    <>
      <p className="text-lg text-[#5F6E79] text-[18px] font-semibold pb-3 pt-6">
        Discount code
      </p>
      <div className="p-3.5 mb-3.5 flex items-center justify-between bg-[#E7EBEC] rounded space-x-10">
        <div className="space-x-4 inline-flex items-center text-[#5F6E79] text-sm font-light w-4/5">
          <i>
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.3346 3.66659L12.3346 4.66658L6.66797 10.3333L5.66797 9.33325L11.3346 3.66659ZM2.33464 0.333252H15.668C16.593 0.333252 17.3346 1.07492 17.3346 1.99992V5.33325C16.8926 5.33325 16.4687 5.50885 16.1561 5.82141C15.8436 6.13397 15.668 6.55789 15.668 6.99992C15.668 7.44195 15.8436 7.86587 16.1561 8.17843C16.4687 8.49099 16.8926 8.66658 17.3346 8.66658V11.9999C17.3346 12.9249 16.593 13.6666 15.668 13.6666H2.33464C1.89261 13.6666 1.46868 13.491 1.15612 13.1784C0.843563 12.8659 0.667969 12.4419 0.667969 11.9999V8.66658C1.59297 8.66658 2.33464 7.92492 2.33464 6.99992C2.33464 6.55789 2.15904 6.13397 1.84648 5.82141C1.53392 5.50885 1.11 5.33325 0.667969 5.33325V1.99992C0.667969 1.55789 0.843563 1.13397 1.15612 0.821407C1.46868 0.508847 1.89261 0.333252 2.33464 0.333252ZM2.33464 1.99992V4.11659C2.84103 4.40858 3.2616 4.8288 3.55401 5.33496C3.84643 5.84112 4.00038 6.41536 4.00038 6.99992C4.00038 7.58447 3.84643 8.15872 3.55401 8.66488C3.2616 9.17103 2.84103 9.59125 2.33464 9.88325V11.9999H15.668V9.88325C15.1616 9.59125 14.741 9.17103 14.4486 8.66488C14.1562 8.15872 14.0022 7.58447 14.0022 6.99992C14.0022 6.41536 14.1562 5.84112 14.4486 5.33496C14.741 4.8288 15.1616 4.40858 15.668 4.11659V1.99992H2.33464ZM6.91797 3.66659C7.60964 3.66659 8.16797 4.22492 8.16797 4.91658C8.16797 5.60825 7.60964 6.16658 6.91797 6.16658C6.2263 6.16658 5.66797 5.60825 5.66797 4.91658C5.66797 4.22492 6.2263 3.66659 6.91797 3.66659ZM11.0846 7.83325C11.7763 7.83325 12.3346 8.39159 12.3346 9.08325C12.3346 9.77492 11.7763 10.3333 11.0846 10.3333C10.393 10.3333 9.83463 9.77492 9.83463 9.08325C9.83463 8.39159 10.393 7.83325 11.0846 7.83325Z"
                fill="#5F6E79"
              />
            </svg>
          </i>
          <span className="truncate">{coupon.name}</span>
        </div>
        <button onClick={handleCodeChange} className="p-1">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.2392 11.1866L5.99917 6.9399L1.75917 11.1866L0.8125 10.2399L5.05917 5.9999L0.8125 1.7599L1.75917 0.813232L5.99917 5.0599L10.2392 0.819899L11.1792 1.7599L6.93917 5.9999L11.1792 10.2399L10.2392 11.1866Z"
              fill="#5F6E79"
            />
          </svg>
        </button>
      </div>
    </>
  );
}
